import { render } from "./kalio-company-program-stats.vue?vue&type=template&id=5ff315d3"
import script from "./kalio-company-program-stats.vue?vue&type=script&lang=js"
export * from "./kalio-company-program-stats.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__